var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg17PhoneStand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.215 525.851L494.739 549.44C494.758 551.389 495.283 552.176 496.856 553.132L503.28 556.669C504.52 557.351 505.972 557.495 507.287 557.065L519.677 553.015C520.135 552.865 520.112 552.211 519.644 552.064L508.519 548.567C507.171 548.03 506.672 547.492 506.463 545.944L505.371 526.72L497.215 525.851ZM500.488 534.371L500.453 539.482C500.448 540.167 501.024 540.731 501.71 540.715C502.337 540.699 502.828 540.2 502.833 539.574L502.868 534.463C502.873 533.779 502.297 533.214 501.611 533.231C500.984 533.246 500.493 533.745 500.488 534.371Z",
    fill: "url(#paint0_linear_1989_5994)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.171 525.826L495.695 549.416C495.714 551.364 496.24 552.151 497.812 553.107L503.984 557.273C505.383 558.217 507.139 558.421 508.67 557.816L520.8 553.024C521.234 552.853 521.193 552.226 520.739 552.084L509.475 548.543C508.127 548.006 507.628 547.468 507.419 545.92L506.327 526.696L498.171 525.826ZM501.444 534.347L501.409 539.458C501.404 540.142 501.98 540.707 502.666 540.69C503.293 540.675 503.784 540.176 503.789 539.55L503.824 534.439C503.829 533.755 503.253 533.19 502.567 533.207C501.94 533.222 501.449 533.721 501.444 534.347Z",
    fill: "url(#paint1_linear_1989_5994)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1989_5994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530 539.285C530 539.16 530 538.994 530 538.869V537.332L529.709 537.956C529.668 537.914 529.626 537.831 529.626 537.789L504.742 512.074C503.662 510.953 502.997 510.703 501.335 511.368L489.205 515.481C488.955 515.564 488.748 515.73 488.582 515.896L488 515.315V517.516C488.042 518.015 488.208 518.472 488.499 518.887L512.303 546.306C513.05 547.427 514.588 547.76 515.709 547.012L528.92 541.154C529.543 540.739 529.917 540.033 530 539.285Z",
    fill: "url(#paint2_linear_1989_5994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.878 539.202L515.709 545.018C514.588 545.766 513.051 545.433 512.303 544.312L488.457 516.893C487.709 515.771 487.834 514.027 489.163 513.487L501.294 509.374C502.956 508.709 503.62 508.958 504.7 510.08L529.585 535.754C530.374 536.917 530.042 538.454 528.878 539.202Z",
    fill: "url(#paint3_linear_1989_5994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.573 519.137L506.611 513.279L525.638 532.929L509.644 539.991L491.573 519.137Z",
    fill: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.887 510.662L497.098 510.786L489.205 513.487C487.875 514.027 487.751 515.771 488.499 516.893L507.234 538.454L497.887 510.662Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.854 513.375C498.036 513.235 498.047 512.945 497.88 512.727C497.712 512.508 497.429 512.444 497.247 512.584C497.065 512.723 497.053 513.014 497.221 513.232C497.388 513.451 497.671 513.515 497.854 513.375Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.636 513.092C497.585 513.132 497.504 513.113 497.456 513.051C497.409 512.989 497.412 512.907 497.464 512.867C497.516 512.827 497.596 512.845 497.644 512.907C497.692 512.97 497.688 513.052 497.636 513.092Z",
    fill: "#305A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.92 537.69C522.46 538.562 522.585 539.559 521.795 540.016C521.006 540.515 519.926 540.182 519.386 539.31C518.846 538.438 518.721 537.441 519.511 536.984C520.258 536.485 521.338 536.817 521.92 537.69Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.629 538.188C522.169 539.061 522.294 540.058 521.504 540.515C520.715 541.013 519.635 540.681 519.095 539.809C518.555 538.936 518.43 537.939 519.22 537.482C519.967 536.984 521.047 537.316 521.629 538.188Z",
    fill: "#555555",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.691 537.956C522.231 538.828 522.356 539.825 521.567 540.282C520.777 540.781 519.697 540.448 519.157 539.576C518.617 538.703 518.492 537.706 519.282 537.249C520.03 536.751 521.11 537.083 521.691 537.956Z",
    fill: "url(#paint4_linear_1989_5994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.719 541.196C527.95 541.196 528.138 540.991 528.138 540.739C528.138 540.486 527.95 540.282 527.719 540.282C527.487 540.282 527.3 540.486 527.3 540.739C527.3 540.991 527.487 541.196 527.719 541.196Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.112 542.697L524.112 542.697L524.11 542.698L521.409 543.861L521.409 543.861L521.405 543.863C521.2 543.966 520.965 543.863 520.898 543.662L520.899 543.662L520.893 543.651C520.791 543.447 520.894 543.211 521.095 543.144L521.095 543.144L521.101 543.142L523.802 541.978L523.802 541.979L523.806 541.976C524.011 541.874 524.246 541.977 524.313 542.178C524.348 542.282 524.339 542.396 524.299 542.494C524.259 542.592 524.19 542.666 524.112 542.697Z",
    fill: "#0C0C0C",
    stroke: "url(#paint5_linear_1989_5994)",
    strokeWidth: 0.166172
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.932 514.094L499.932 514.094L499.925 514.097L497.228 515.217C497.038 515.279 496.841 515.188 496.736 515.022C496.704 514.919 496.709 514.837 496.736 514.775C496.763 514.713 496.821 514.658 496.923 514.624L496.923 514.624L496.929 514.622L499.543 513.584C499.647 513.55 499.746 513.552 499.829 513.584C499.912 513.615 499.986 513.679 500.038 513.782L500.037 513.783L500.042 513.789C500.097 513.882 500.101 513.942 500.089 513.978C500.078 514.013 500.041 514.058 499.932 514.094Z",
    fill: "#0A0A0A",
    stroke: "url(#paint6_linear_1989_5994)",
    strokeWidth: 0.207715
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M521.048 539.149L521.048 539.149L521.047 539.149L520.371 539.472L520.371 539.472L520.369 539.473C520.277 539.523 520.127 539.475 520.075 539.334L520.076 539.334L520.072 539.327L519.632 538.587C519.609 538.534 519.608 538.466 519.631 538.403C519.653 538.339 519.698 538.284 519.759 538.258L519.759 538.258L519.76 538.257L520.436 537.935L520.436 537.935L520.438 537.933C520.53 537.883 520.681 537.932 520.732 538.072L520.731 538.073L520.735 538.079L521.174 538.818C521.225 538.96 521.171 539.095 521.048 539.149Z",
    stroke: "#7B7C7C",
    strokeWidth: 0.0830861
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_5994",
    x1: 506.558,
    y1: 525.621,
    x2: 507.344,
    y2: 557.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E131A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_5994",
    x1: 507.586,
    y1: 525.595,
    x2: 508.394,
    y2: 558.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706263,
    stopColor: "#495563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20252B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1989_5994",
    x1: 488.623,
    y1: 516.893,
    x2: 514.38,
    y2: 547.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1989_5994",
    x1: 495.27,
    y1: 511.493,
    x2: 523.104,
    y2: 541.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1989_5994",
    x1: 520.424,
    y1: 537.017,
    x2: 520.424,
    y2: 540.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1989_5994",
    x1: 520.196,
    y1: 544.104,
    x2: 524.558,
    y2: 542.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.269429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1989_5994",
    x1: 501.294,
    y1: 512.947,
    x2: 495.893,
    y2: 515.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005886,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18171E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1989_5994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 38.4273,
    fill: "white",
    transform: "translate(488 509)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg17PhoneStand);
export default __webpack_public_path__ + "static/media/17PhoneStand.9efcbe4f8def8f418c45f384d694a64c.svg";
export { ForwardRef as ReactComponent };